import { forwardRef } from 'react';
import samantha3 from '../../assets/samantha3.webp';
import samantha2 from '../../assets/samantha2.webp';
import styles from './ListenNowSection.module.css';

const listenLinks = [
  {
    id: 1,
    image: samantha3,
    buttonText: 'Listen on Spotify',
    link: 'https://open.spotify.com/artist/5pkW6DUPl8HPruBeQkyUiL?si=bo053dzYShWRQUL6UQLLdQ', 
    bgClass: styles.leftBackground,
  },
  {
    id: 2,
    image: samantha2,
    buttonText: 'Listen on Apple Music',
    link: 'https://music.apple.com/us/artist/samantha-shen/591938191', 
    bgClass: styles.rightBackground,
  },
];

const ListenNowSection = forwardRef((props, ref) => {
  return (
    <section ref={ref} className={styles.section}>
      {listenLinks.map((item) => (
        <div key={item.id} className={`${styles.column} ${item.bgClass}`}>
          <img src={item.image} alt={item.buttonText} className={styles.image} />
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.button}
          >
            {item.buttonText}
          </a>
        </div>
      ))}
    </section>
  );
});

export default ListenNowSection;
